<div class="grid-container" *ngIf="context$ | async as context">
	<dx-data-grid [dataSource]="context.activityLogs" height="calc(100vh - 370px)">
		<dxo-filter-row [visible]="true"></dxo-filter-row>
		<dxo-header-filter [visible]="true"></dxo-header-filter>

		<dxo-selection mode="none"></dxo-selection>

		<dxo-scrolling mode="standard" showScrollbar="always"></dxo-scrolling>

		<dxo-editing mode="batch" [allowUpdating]="false" [allowAdding]="false" [allowDeleting]="false"></dxo-editing>

		<dxo-paging [pageSize]="50"></dxo-paging>

		<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[25, 50, 100]"></dxo-pager>

		<dxi-column dataField="userName" caption="User"></dxi-column>
		<dxi-column dataField="creationDate" caption="Activity date/time" [sortIndex]="1" sortOrder="desc" cellTemplate="creationDateCellTemplate"></dxi-column>

		<div *dxTemplate="let d of 'creationDateCellTemplate'">
			{{d.data.creationDate | timezoneDate : context.timezone : context.dateTimeFormat}}
		</div>

		<dxi-column dataField="loadedDate" caption="Loaded date" [format]="context.dateFormat"></dxi-column>
		<dxi-column *ngIf="hasEndDates" dataField="loadedEndDate" caption="Loaded end date"></dxi-column>
		<dxi-column dataField="linesLoaded" caption="# Lines Loaded"></dxi-column>
	</dx-data-grid>
</div>
